module.exports = __webpack_public_path__ + "static/slider4-9c0a5db21a66b6d290ce564320b52886.jpg";